import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GCADAConfigService } from '@GCADA/services/config.service';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { MatSnackBar } from '@angular/material';
import { GCADASidebarService } from '@GCADA/components/sidebar/sidebar.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {

    public rightNavbar: boolean;
    public hiddenNavbar: boolean;
    public userStatusOptions: any[];
    public horizontalNavbar: boolean;


    //Inside the view
    public userFullname: string;
    public userEmailaddress: string;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {GCADAConfigService} _GCADAConfigService
     * @param {GCADASidebarService} _GCADASidebarService
     * @param {TranslateService} _translateService
     * @param {Router} _router
     */
    constructor(private _router: Router,
        public _snackBar: MatSnackBar,
        private _authService: AuthService,
        private _GCADASidebarService: GCADASidebarService,
        private _GCADAConfigService: GCADAConfigService) {

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }
    /**
     * On init
     */
    ngOnInit(): void {
        //Get user detail
        this.userFullname = localStorage.getItem("firstName") + " " + localStorage.getItem("lastName");
        this.userEmailaddress = localStorage.getItem("email");

        // Subscribe to the config changes
        this._GCADAConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._GCADASidebarService.getSidebar(key).toggleOpen();
    }

    //Go to login page
    gotoLoginPage() {
        this._authService.logout().then((data) => {
            localStorage.clear();
            this._router.navigateByUrl("/pages/auth/login");
        }).catch((error) => { });
    }

    //Go to change password
    gotoChangePassword() {
        this._router.navigateByUrl("/apps/admin/change-password");
    }
}
